import { convertFormDateTimeValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';

import { IKnmErknmEventSubmittedDocumentsForm } from '../interfaces/IKnmErknmEventSubmittedDocumentsForm';
import { IKnmErknmEventSubmittedDocuments } from '../interfaces/IKnmErknmEventSubmittedDocuments';

export const convertActEventStudiedDocumentsFormValueToKnmData = (
  documents?: IKnmErknmEventSubmittedDocumentsForm[] | undefined,
): IKnmErknmEventSubmittedDocuments[] | undefined => {
  if (!documents) {
    return undefined;
  }

  return documents.map(doc => {
    const document: IKnmErknmEventSubmittedDocuments = {
      ...doc,
      requestDateTime: convertFormDateTimeValueToKnmDataDate(doc.requestDateTime, false) || undefined,
      submissionDateTime: convertFormDateTimeValueToKnmDataDate(doc.submissionDateTime, false) || undefined,
      submissionDeadline: convertFormDateTimeValueToKnmDataDate(doc.submissionDeadline, true) || undefined,
      status: {
        code: doc.status?.code || '',
        id: doc.status?.id || 0,
        title: doc.status?.title || '',
        weight: doc.status?.weight || 0,
      },
    };

    return document;
  });
};
